import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'HomeMain',
        // component: HomeMain
        component: () => import('@/views/home/HomeMain.vue'),
    },
    {
        path: '/home/stplatSrv',
        name: 'StplatService',
        // component: TermsService
        component: () => import('@/views/home/StipulationService.vue'),
    },
    // {
    //     path: '/home/terSrv',
    //     name: 'TermsService',
    //     // component: TermsService
    //     component: () => import('@/views/home/TermsService.vue'),
    // },
    // {
    //     path: '/home/locSrv',
    //     name: 'LocationService',
    //     // component: TermsService
    //     component: () => import('@/views/home/LocationService.vue'),
    // },
    // {
    //     path: '/home/privcySrv',
    //     name: 'PrivacyService',
    //     component: () => import('@/views/home/PrivacyService.vue'),
    // },
    {
        path: '/home/ntc',
        name: 'NoticeList',
        component: () => import('@/views/home/bbs/NoticeList.vue'),
    },
    {
        path: '/home/ntc/info/:token',
        name: 'NoticeInfo',
        component: () => import('@/views/home/bbs/NoticeInfo.vue'),
    },
    {
        path: '/home/faq',
        name: 'FaqList',
        component: () => import('@/views/home/bbs/FaqList.vue'),
    },
    {
        path: '/home/faq/info/:token',
        name: 'FaqInfo',
        component: () => import('@/views/home/bbs/FaqInfo.vue'),
    },
    // {
    //     path: '/home/secsn',
    //     name: 'SecsnService',
    //     component: () => import('@/views/home/SecsnService.vue'),
    // },
    {
        path: "/error",
        name: "notFound",
        component: () => import('@/views/NotFound.vue'),
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/error"
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
